<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="square" stroke-width="3.931">
        <path d="M40.345 3.655l-36.69 36.69M40.345 40.345L3.655 3.655"/>
    </g>
</svg>
